type Listener<T = any> = (...args: T[]) => void;

class EventBus {
  private events: Record<string, Listener[]> = {};

  // 添加事件监听器
  on<T>(event: string, listener: Listener<T>): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }

  // 触发事件
  emit<T>(event: string, ...args: T[]): void {
    if (this.events[event]) {
      this.events[event].forEach((listener) => listener(...args));
    }
  }

  // 移除事件监听器
  off<T>(event: string, listener: Listener<T>): void {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(
        (l) => l !== listener
      );
    }
  }
}

const eventBus = new EventBus();

export default eventBus;
